import {BaseFirebaseModel} from '../../bases/baseFirebaseModel';

export class NotificationBase extends BaseFirebaseModel {


}
